import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button } from "react-bootstrap";

interface AddCriteriaProps {
    label: string;
    icon: IconProp;
    handleOnClick: () => void;
}

export const AddFullButton = ({ label, icon, handleOnClick }: AddCriteriaProps) => {
    return (
        <Button type="button" onClick={handleOnClick} className="button-add-file w-full border-dashed d-flex align-items-center gap-2 text-primary">
            <FontAwesomeIcon icon={icon} />
            { label }
        </Button>
    );
}